<div class="phx-alert-prefix-icon" *ngIf="phxAlertType !== 'settings-banner' && phxHasIcon">
  <i phx-icon [phxIcon]="prefixIcon" [size]="20"></i>
</div>
<div class="phx-alert-content">
  <ng-content class="phx-alert-content-title" select="[phx-alert-title]"></ng-content>
  <ng-content select="[phx-alert-content]"></ng-content>
  <ng-container *ngIf="phxOrientation === 'vertical'" [ngTemplateOutlet]="actions"></ng-container>
</div>
<ng-container *ngIf="phxOrientation === 'horizontal'" [ngTemplateOutlet]="actions"></ng-container>
<div class="phx-alert-suffix-icon" *ngIf="phxAlertType !== 'settings-banner' && phxClosable">
  <button phx-icon-button [phxIcon]="crossIcon" phxIconButtonSize="small" (click)="onClosed()"></button>
</div>

<ng-template #actions>
  <div class="phx-alert-actions">
    <ng-content select="[phx-alert-actions]"></ng-content>
  </div>
</ng-template>
